//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../Features/Features.ShipDesign.SteelFeatureSpreadsheetBuilder.js";
import "../no/SelectEdge.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
import "../no/Features.js";
let d=[[[1,"AdditionalStructures",0,"ScCollector",0],[0,"BasePlaneType",1,0],[0,"DrawingSuffixName",1,0],[0,"OrientationCsys",1,"CoordinateSystem",0],[1,"PinJigData",0,"Features.ShipDesign.SteelFeatureSpreadsheetBuilder",0],[1,"Plates",0,"ScCollector",0],[1,"XDirectionEdge",0,"SelectEdge",0]],[],[]];
SPLM.Features.ShipDesign.PinJigBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.PinJigBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.PinJigBuilder.BasePlaneTypes = Object.freeze({
    "Inferred" : "Inferred", "AverageTangent" : "AverageTangent"});

export default SPLM;